// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteHostedPageModal .DeleteHostedPageModal-Title .MuiTypography-root{color:#fff}`, "",{"version":3,"sources":["webpack://./src/components/gms/DeleteHostedPageModal/DeleteHostedPageModal.scss"],"names":[],"mappings":"AAAA,wEACE,UAAA","sourcesContent":[".DeleteHostedPageModal .DeleteHostedPageModal-Title .MuiTypography-root {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
